import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-power-study-metrics',
	templateUrl: './power-study-metrics.component.html',
	styleUrls: ['./power-study-metrics.component.css']
})
export class PowerStudyMetricsComponent {
	@Input() data: any = {};
	@Input() selectedDays: any;
	@Input() device: any = {};
	@Input() studyInfo: any;
	@Input() onPrint: boolean = false;

	@Input() siteInfo: any = {};
	@Input() selectedPeriodFormatted!: string;
}
